import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const MaterialsCaptureSuccess = () => {
  const { formulationsObj } = useContext(MaterialsCaptureContext);

  return(
    <Box>
      <Box 
        sx={{
          mt: 1, 
          display: 'flex', 
          justifyContent: 'center'
        }}
      >
        {/* <Box
          component='img'
          src='/material.jpg'
          alt='Materials Image'
          sx={{
            height: 300,
            width: '100%',
          }}
        /> */}
      </Box>

      <Box m={[0, 2, 0, 2]}>
        <Typography variant='h4' gutterBottom>
          Success🎉!
        </Typography>
        <Typography variant="body1" gutterBottom>
          Materials Capture for {formulationsObj?.type}(s) has been successfully recorded. The following {formulationsObj?.type === 'Plate' ? 'plates' : 'samples'} were processed: {formulationsObj?.ids.map(item => item?.name).join(',')}. You can now proceed with the next steps or review the entered data.
        </Typography>
      </Box>
    </Box>
  );
};

export default MaterialsCaptureSuccess;